export const ResellerType = {
    OMNIPAY: 'OmniPay',
    DATMAN: 'Datman'
};

export const ResellerNameAndId = [
    { id: 1, name: 'OmniPay' },
    { id: 2, name: 'Datman' }
];
